"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberOfNotificationsBadge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var baseClassName = 'badge badge-indicator';
var badgePingTimeoutMs = 5000;
var NumberOfNotificationsBadge = function (props) {
    var count = props.count, priority = props.priority;
    var _a = (0, react_1.useState)("".concat(baseClassName, " badge-primary")), className = _a[0], setClassName = _a[1];
    var setPingingEffect = function (internalClassname) {
        return setClassName("".concat(internalClassname, " badge-indicator-pinging"));
    };
    var unSetPingingEffect = function (internalClassname) { return function () { return setClassName("".concat(internalClassname)); }; };
    (0, react_1.useEffect)(function () {
        var badgePrio = (function () {
            switch (priority) {
                case 'HIGH':
                    return 'badge-danger';
                case 'MEDIUM':
                    return 'badge-warning';
                default:
                    return 'badge-primary';
            }
        })();
        var classNameWithPrio = "".concat(baseClassName, " ").concat(badgePrio);
        setPingingEffect(classNameWithPrio);
        var timer = setTimeout(unSetPingingEffect(classNameWithPrio), badgePingTimeoutMs);
        return function () { return clearTimeout(timer); };
    }, [count, priority]);
    var displayedCount = count > 10 ? '10+' : count;
    return count > 0 ? (0, jsx_runtime_1.jsx)("span", { className: className, children: displayedCount }) : null;
};
exports.NumberOfNotificationsBadge = NumberOfNotificationsBadge;
